import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useEffect, useState } from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { FormControl } from "@material-ui/core";
import { isAfter, isValid, subYears, startOfDay } from "date-fns";
var DateTimePicker = function DateTimePicker(_a) {
  var id = _a.id,
    required = _a.required,
    onChange = _a.onChange,
    value = _a.value,
    validationError = _a.validationError,
    preventFutureDate = _a.preventFutureDate,
    _a$format = _a.format,
    format = _a$format === void 0 ? "MM/dd/yyyy" : _a$format,
    props = __rest(_a, ["id", "required", "onChange", "value", "validationError", "preventFutureDate", "format"]);
  var _useState = useState(validationError),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    curValue = _useState4[0],
    setCurValue = _useState4[1];
  /**
   * Normalize today to the beginning of the day.
   *
   * This is important because:
   * new Date() contains the current time.
   *
   * For example:
   *   Today:    08/28/2026 02:17 PM
   *   125 ago:  08/28/1901 02:17 PM
   *
   * But a date entered through the picker may be:
   *   08/28/1901 12:00 AM
   *
   * Comparing those directly would incorrectly reject the date.
   */
  var today = startOfDay(new Date());
  /**
   * Exactly 125 years ago is allowed.
   *
   * Example:
   * If today is 08/28/2026:
   *
   * 08/28/1901 -> valid
   * 08/27/1901 -> invalid
   */
  var minDate = subYears(today, 125);
  useEffect(function () {
    setError(validationError);
  }, [validationError]);
  useEffect(function () {
    if (!value) {
      setCurValue(null);
      return;
    }
    // If value is a YYYY-MM-DD string, convert it to a local Date.
    // This prevents timezone/UTC date shifting.
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      var _value$split$map = value.split("-").map(Number),
        _value$split$map2 = _slicedToArray(_value$split$map, 3),
        year = _value$split$map2[0],
        month = _value$split$map2[1],
        day = _value$split$map2[2];
      setCurValue(new Date(year, month - 1, day));
      return;
    }
    setCurValue(value);
  }, [value]);
  var handleChange = function handleChange(date, _value) {
    setCurValue(date);
    /**
     * Validation
     */
    if (!date) {
      if (required) {
        setError("Value is required");
      } else {
        setError("");
      }
      return;
    }
    if (!isValid(date)) {
      setError("Enter a valid date");
      return;
    }
    /**
     * Normalize the selected date before performing date-only
     * comparisons.
     */
    var selectedDate = startOfDay(date);
    if (preventFutureDate && isAfter(selectedDate, today)) {
      setError("Date cannot be in the future");
    } else if (selectedDate < minDate) {
      setError("Date cannot be more than 125 years old");
    } else {
      setError("");
    }
    /**
     * Keep the original behavior of adding the current time when
     * the selected date is midnight.
     */
    var processedDate = date;
    if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0) {
      var now = new Date();
      processedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    }
    if (onChange) {
      onChange(processedDate);
    }
  };
  return React.createElement(FormControl, {
    fullWidth: true,
    error: Boolean(error),
    id: id
  }, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, React.createElement(KeyboardDatePicker, Object.assign({
    format: format,
    value: curValue,
    disableFuture: preventFutureDate,
    error: Boolean(error),
    FormHelperTextProps: {
      error: Boolean(error)
    },
    helperText: error,
    minDate: minDate,
    minDateMessage: "Date cannot be more than 125 years old",
    required: required,
    allowKeyboardControl: true,
    KeyboardButtonProps: {
      "aria-label": "change date"
    }
  }, props, {
    onChange: handleChange
  }))));
};
export default DateTimePicker;